module.exports = __webpack_public_path__ + "static/shoe-red-1-77cf89b2b3cbcde2916845559230d91b.png";